import { AnimatePresence, motion } from "framer-motion"
import landing_bg from 'src/assets/landing_bg.jpg'

type LandingLayoutProps = {
  children?: React.ReactNode
}

const LandingLayout = ({ children }: LandingLayoutProps) => {
  return (
    <div className="dark:bg-dark-950 bg-slate-700 min-h-screen absolute w-full bg-cover" style={{ backgroundImage: `url(${landing_bg})` }}>
      <motion.main
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }} className="grid h-screen place-items-center">
        <div className="dark:bg-black/80 bg-slate-50 shadow-lg relative z-10">{children}</div>
      </motion.main>
    </div>
  )
}

export default LandingLayout
